import type { UnitOfMeasurement } from "@/graphql/codegen/graphql"

export const getUomName = (units: UnitOfMeasurement[], uomId?: string | null): string => {
  if (!uomId) return ""
  return units.find((unit) => unit.id === uomId)?.name ?? ""
}
